'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'wand-magic-sparkles';
var width = 576;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = ['M80 428c0 1.3 .5 2.6 1.5 3.5l31 31c.9 .9 2.2 1.5 3.5 1.5s2.6-.5 3.5-1.5L354.1 228 316 189.9 81.5 424.5c-.9 .9-1.5 2.2-1.5 3.5z', 'M256-32c3.3 0 6.2 2 7.4 5L278.2 9.8 315 24.6c3 1.2 5 4.2 5 7.4s-2 6.2-5 7.4L278.2 54.2 263.4 91c-1.2 3-4.2 5-7.4 5s-6.2-2-7.4-5L233.8 54.2 197 39.4c-3-1.2-5-4.2-5-7.4s2-6.2 5-7.4L233.8 9.8 248.6-27c1.2-3 4.2-5 7.4-5zM460 48c-1.3 0-2.6 .5-3.5 1.5L349.9 156 388 194.1 494.5 87.5c.9-.9 1.5-2.2 1.5-3.5s-.5-2.6-1.5-3.5l-31-31c-.9-.9-2.2-1.5-3.5-1.5zM81.5 424.5c-.9 .9-1.5 2.2-1.5 3.5s.5 2.6 1.5 3.5l31 31c.9 .9 2.2 1.5 3.5 1.5s2.6-.5 3.5-1.5L354.1 228 316 189.9 81.5 424.5zm341.1-409C432.5 5.6 446 0 460 0s27.5 5.6 37.5 15.5l31 31C538.4 56.5 544 70 544 84s-5.6 27.5-15.5 37.5l-375 375C143.5 506.4 130 512 116 512s-27.5-5.6-37.5-15.5l-31-31C37.6 455.5 32 442 32 428s5.6-27.5 15.5-37.5l375-375zM110.7 41.7l21.5 50.1 50.1 21.5c5.9 2.5 9.7 8.3 9.7 14.7s-3.8 12.2-9.7 14.7l-50.1 21.5-21.5 50.1c-2.5 5.9-8.3 9.7-14.7 9.7s-12.2-3.8-14.7-9.7L59.8 164.2 9.7 142.7C3.8 140.2 0 134.4 0 128s3.8-12.2 9.7-14.7L59.8 91.8 81.3 41.7C83.8 35.8 89.6 32 96 32s12.2 3.8 14.7 9.7zm368 272l21.5 50.1 50.1 21.5c5.9 2.5 9.7 8.3 9.7 14.7s-3.8 12.2-9.7 14.7l-50.1 21.5-21.5 50.1c-2.5 5.9-8.3 9.7-14.7 9.7s-12.2-3.8-14.7-9.7l-21.5-50.1-50.1-21.5c-5.9-2.5-9.7-8.3-9.7-14.7s3.8-12.2 9.7-14.7l50.1-21.5 21.5-50.1c2.5-5.9 8.3-9.7 14.7-9.7s12.2 3.8 14.7 9.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;